import { render, staticRenderFns } from "./CreditNoteCreateView.vue?vue&type=template&id=6ffea670"
import script from "./CreditNoteCreateView.vue?vue&type=script&lang=js"
export * from "./CreditNoteCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports